import Papa from 'papaparse';
import { parseTimeToSeconds } from './timeUtils';

export const fetchSwimmerData = async (file) => {
  const response = await fetch(file);
  if (!response.ok) throw new Error(`Failed to fetch ${file}`);
  const data = await response.json();
  return data;
};

export const fetchStandards = async (file) => {
  const response = await fetch(file);
  if (!response.ok) throw new Error(`Failed to fetch ${file}`);
  const text = await response.text();
  return new Promise((resolve, reject) => {
    Papa.parse(text, {
      header: true,
      skipEmptyLines: true,
      complete: (result) => resolve(result.data),
      error: (err) => reject(err),
    });
  });
};

export const getAgeGroup = (age) => {
  if (age <= 9) return '9&U';
  if (age >= 15 && age <= 18) return '15-18';
  return age.toString();
};

export const meetsStandard = (time, standardTime) => {
  const timeSeconds = parseTimeToSeconds(time);
  const standardSeconds = parseTimeToSeconds(standardTime);
  return timeSeconds <= standardSeconds;
};